module.exports = __webpack_public_path__ + "static/media/php.1da4b071.png";